/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
import { addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import viLocaleData from 'react-intl/locale-data/vi';
import frLocaleData from 'react-intl/locale-data/fr';
import esLocaleData from 'react-intl/locale-data/es';

import { DEFAULT_LOCALE } from '../app/containers/App/constants';

import enTranslationMessages from './locales/en/translation.json';
import viTranslationMessages from './locales/vi/translation.json';
import frTranslationMessages from './locales/fr/translation.json';
import esTranslationMessages from './locales/es/translation.json';

// Add all locale data
addLocaleData(enLocaleData);
addLocaleData(viLocaleData);
addLocaleData(frLocaleData);
addLocaleData(esLocaleData);

const getConfiguredLocales = () => {
  if (typeof VARS !== 'undefined' && VARS.REACT_APP_LOCALE) {
    try {
      let localeConfig = VARS.REACT_APP_LOCALE;

      if (typeof localeConfig === 'string') {
        localeConfig = JSON.parse(localeConfig);
      }

      if (localeConfig && localeConfig.locales && Array.isArray(localeConfig.locales)) {
        return localeConfig.locales;
      }
    } catch (error) {
      console.warn('Error parsing REACT_APP_LOCALE config:', error);
    }
  }

  return ['en', 'fr'];
};

export const appLocales = getConfiguredLocales();

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages = locale !== DEFAULT_LOCALE
    ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
    : {};
  return Object.keys(messages).reduce((formattedMessages, key) => {
    const formattedMessage = !messages[key] && locale !== DEFAULT_LOCALE
      ? defaultFormattedMessages[key]
      : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  }, {});
};

// Create translation messages only for configured locales
const createTranslationMessages = () => {
  const messages = {};
  const configuredLocales = getConfiguredLocales();

  // Map of available translation files
  const translationFiles = {
    en: enTranslationMessages,
    vi: viTranslationMessages,
    fr: frTranslationMessages,
    es: esTranslationMessages,
  };

  configuredLocales.forEach((locale) => {
    if (translationFiles[locale]) {
      messages[locale] = formatTranslationMessages(locale, translationFiles[locale]);
    }
  });

  return messages;
};

export const translationMessages = createTranslationMessages();



// WEBPACK FOOTER //
// ./app/i18n.js